export const GET_SURVEY_QUESTIONS = 'GET_SURVEY_QUESTIONS';
export const GET_SURVEY_QUESTIONS_SUCCESS = 'GET_SURVEY_QUESTIONS_SUCCESS';
export const SEND_SURVEY_ANSWERS = 'SEND_SURVEY_ANSWERS';
export const SEND_SURVEY_ANSWERS_SUCCESS = 'SEND_SURVEY_ANSWERS_SUCCESS';
export const SEND_SURVEY_ANSWERS_ERROR = 'SEND_SURVEY_ANSWERS_ERROR';
